export const ApiUrl = `https://koncurent.com:3000`;
// export const ApiUrl = `https://staging.koncurent.com:3000`;
